const initialState = () => ({
  multimedias: [], // Arreglo de archivos multimedia
})

export default initialState
